import React from 'react';

export default ({ clickModify }) => { 
    return (<button type="button" className="btn btn-primary mt-3" data-toggle="tooltip" title="Modifier" onClick={clickModify}>
        Modifier  <i className="fas fa-fw fa-pen" />
    </button>)
}